// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lateral-panel {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 200px;
  padding: 20px 10px;
  background: rgba(255, 255, 255, 0.55);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  z-index: 500;
  font-family: 'Roboto', sans-serif;
}

.panel-item-container {
  margin-top: 100px;
}

.panel-item {
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  display: flex;
  align-items: center;
  padding: 10px;
  margin-top: 30px;
  margin-left: 15px;
  color: rgba(0, 0, 0, 0.5);
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: color 0.3s ease-in-out;
  text-decoration: none;
}

.panel-item.active {
  color: rgb(0, 0, 0);
  font-weight: 500;
}

.icon {
  margin-right: 10px;
  font-size: 25px;


}

.dot {
  display: inline-block;
  height: 10px;
  width: 10px;
  margin-top: 3px;
  background-color: rgb(0, 0, 0);
  border-radius: 50%;
  margin-left: 10px;
  opacity: 0;
  animation: fadeIn 0.4s ease-in-out forwards;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.panel-item.active.dot {
  opacity: 1;
}

.lateral-panel.hidden {
  transform: translateX(-100%);
  transition: transform 0.5s ease;
}

.lateral-panel.visible {
  transform: translateX(0%);
  transition: transform 0.5s ease 0.9s;
}

.lateral-panel a {
  text-decoration: none; /* Retire la décoration de texte pour tous les liens dans le panneau latéral */
}


@media only screen and (max-width: 1400px) {
  .lateral-panel {

    width: 170px;
  }
}

.panel-item {
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  display: flex;
  align-items: center;
  padding: 10px;
  margin-top: 20px;
  margin-left: 6px;
  font-size: 18px;
  margin-bottom: 5px;

}

.icon {
  margin-right: 7px;
}

.dot {
  height: 10px;
  width: 10px;
  margin-top: 3px;
  background-color: rgb(0, 0, 0);
  border-radius: 50%;
  margin-left: 10px;
}

@media only screen and (max-width: 750px) {

  .panel-item-container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    margin-left: 15px;
    height: 320px;
    width: 27px;
    padding: 5px 10px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.55);
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px);
    z-index: 500;
    font-family: 'Roboto', sans-serif;
    transition: transform 0.5s ease, opacity 0.5s ease;
  }

  .dot {
    height: 8px;
    width: 8px;
    margin-top: -9px;
    background-color: rgb(0, 0, 0);
    border-radius: 50%;
    margin-left: -7px;
  }

  .panel-item.active .dot {
    opacity: 1;
  }

  .panel-item-container.hidden {
    transform: translateX(-100%);
    transition: transform 0.5s ease;
  }
  
  .panel-item-container.visible {
    transform: translateX(0%);
    transition: transform 0.5s ease 0.9s;
  }

  .panel-item-container a {
    text-decoration: none;
  }

  .lateral-panel {
    width: 0px;
    background-color: transparent;
    -webkit-backdrop-filter: blur(0px);
            backdrop-filter: blur(0px);
  }

  .panel-item {
    margin-top: 20px;
    margin-left: -10px;
    color: rgba(0, 0, 0, 0.6);
  }

  .icon {
    margin-right: 10px;
    margin-top: -10px;
    color: rgba(0, 0, 0, 0.4);
    font-size: 18px;
  }

  .panel-item.active .icon {
    color: rgb(0, 0, 0);
    font-weight: 500;
  }

  .text.hidden {
    display: none;
  }

  .text.visible {
    display: none;
  }

  .panel-item.agent {
    margin-top: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/pages-style/lateral_panel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,kCAA0B;UAA1B,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;;;AAGjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB,EAAE,8EAA8E;AACvG;;;AAGA;EACE;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,kCAA0B;YAA1B,0BAA0B;IAC1B,YAAY;IACZ,iCAAiC;IACjC,kDAAkD;EACpD;;EAEA;IACE,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,6BAA6B;IAC7B,kCAA0B;YAA1B,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".lateral-panel {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 200px;\n  padding: 20px 10px;\n  background: rgba(255, 255, 255, 0.55);\n  backdrop-filter: blur(8px);\n  z-index: 500;\n  font-family: 'Roboto', sans-serif;\n}\n\n.panel-item-container {\n  margin-top: 100px;\n}\n\n.panel-item {\n  font-family:Verdana, Geneva, Tahoma, sans-serif;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  margin-top: 30px;\n  margin-left: 15px;\n  color: rgba(0, 0, 0, 0.5);\n  border: none;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n  transition: color 0.3s ease-in-out;\n  text-decoration: none;\n}\n\n.panel-item.active {\n  color: rgb(0, 0, 0);\n  font-weight: 500;\n}\n\n.icon {\n  margin-right: 10px;\n  font-size: 25px;\n\n\n}\n\n.dot {\n  display: inline-block;\n  height: 10px;\n  width: 10px;\n  margin-top: 3px;\n  background-color: rgb(0, 0, 0);\n  border-radius: 50%;\n  margin-left: 10px;\n  opacity: 0;\n  animation: fadeIn 0.4s ease-in-out forwards;\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.panel-item.active.dot {\n  opacity: 1;\n}\n\n.lateral-panel.hidden {\n  transform: translateX(-100%);\n  transition: transform 0.5s ease;\n}\n\n.lateral-panel.visible {\n  transform: translateX(0%);\n  transition: transform 0.5s ease 0.9s;\n}\n\n.lateral-panel a {\n  text-decoration: none; /* Retire la décoration de texte pour tous les liens dans le panneau latéral */\n}\n\n\n@media only screen and (max-width: 1400px) {\n  .lateral-panel {\n\n    width: 170px;\n  }\n}\n\n.panel-item {\n  font-family:Verdana, Geneva, Tahoma, sans-serif;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  margin-top: 20px;\n  margin-left: 6px;\n  font-size: 18px;\n  margin-bottom: 5px;\n\n}\n\n.icon {\n  margin-right: 7px;\n}\n\n.dot {\n  height: 10px;\n  width: 10px;\n  margin-top: 3px;\n  background-color: rgb(0, 0, 0);\n  border-radius: 50%;\n  margin-left: 10px;\n}\n\n@media only screen and (max-width: 750px) {\n\n  .panel-item-container {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    margin-left: 15px;\n    height: 320px;\n    width: 27px;\n    padding: 5px 10px;\n    border-radius: 20px;\n    background: rgba(255, 255, 255, 0.55);\n    backdrop-filter: blur(8px);\n    z-index: 500;\n    font-family: 'Roboto', sans-serif;\n    transition: transform 0.5s ease, opacity 0.5s ease;\n  }\n\n  .dot {\n    height: 8px;\n    width: 8px;\n    margin-top: -9px;\n    background-color: rgb(0, 0, 0);\n    border-radius: 50%;\n    margin-left: -7px;\n  }\n\n  .panel-item.active .dot {\n    opacity: 1;\n  }\n\n  .panel-item-container.hidden {\n    transform: translateX(-100%);\n    transition: transform 0.5s ease;\n  }\n  \n  .panel-item-container.visible {\n    transform: translateX(0%);\n    transition: transform 0.5s ease 0.9s;\n  }\n\n  .panel-item-container a {\n    text-decoration: none;\n  }\n\n  .lateral-panel {\n    width: 0px;\n    background-color: transparent;\n    backdrop-filter: blur(0px);\n  }\n\n  .panel-item {\n    margin-top: 20px;\n    margin-left: -10px;\n    color: rgba(0, 0, 0, 0.6);\n  }\n\n  .icon {\n    margin-right: 10px;\n    margin-top: -10px;\n    color: rgba(0, 0, 0, 0.4);\n    font-size: 18px;\n  }\n\n  .panel-item.active .icon {\n    color: rgb(0, 0, 0);\n    font-weight: 500;\n  }\n\n  .text.hidden {\n    display: none;\n  }\n\n  .text.visible {\n    display: none;\n  }\n\n  .panel-item.agent {\n    margin-top: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
